module.exports = __webpack_public_path__ + "img/1.819d9a1e.png";